import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import translate from "@insite/client-framework/Translate";
import StoreIcon from "@NA/Icons/StoreIcon";
import DeliveryTruck from "@NA/Icons/DeliveryTruck";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { ProductDetailsPageContext } from "@insite/content-library/Pages/ProductDetailsPage";
import Img from "@insite/mobius/Img";
import Typography from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import ADIColors from "@NA/Utils/ADIColors"
import * as React from "react";
import { getSession } from "@insite/client-framework/Store/Context/ContextSelectors"
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";
import Truck from "@insite/mobius/Icons/Truck";
import { getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import { CartPageContext } from "@insite/content-library/Pages/CartPage";
import Modal from "@insite/mobius/Modal";
import Zone from "@insite/client-framework/Components/Zone";
import Button from "@insite/mobius/Button";
import Link from "@insite/mobius/Link";
import parse from "html-react-parser";
import { parserOptions } from "@insite/client-framework/Common/BasicSelectors";
import { UnorderedList } from "@insite/mobius/Lists";
import ProductComapreCheckbox from "@NA/Widgets/ProductCompare/ProductCompareCheckbox";
import ListItem from "@insite/mobius/Lists/ListItem";
import e from "express";
import { SectionOptionModel, SpecificationModel } from "@insite/client-framework/Types/ApiModels";
import { contentStyles } from "@insite/content-library/Widgets/BrandDetails/BrandDetailsContent";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";

export interface ProductDetailsShippingCountdownStyles {
    containerStyles?: InjectableCss;
    dataContainerStyles?: InjectableCss;
    productCompareCheckbox?: InjectableCss;
    spanHeader?: InjectableCss;
};

const mapStateToProps = (state: ApplicationState) => {
    const isAuthenticated = state.context.session!.isAuthenticated;
    const cartState = state.data.carts;
    const cartId = cartState?.currentId || "";
    const cart = cartState?.byId[cartId];

    return {
        isAuthenticated,
        session: getSession(state),
        cartId: cartId,
        cart: cart,
        currencySymbol: state.context.session.currency?.currencySymbol ?? "",
    };
};

const mapDispatchToProps = {
};


type Props = WidgetProps & HasProduct & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;;

const ProductDetailsShippingCountdown: React.FC<Props> = ({
    currencySymbol,
    product,
    isAuthenticated,
    session,
    cartId,
    cart,
    id,
}) => {
    const [openKeyFeaturesSection, setOpenKeyFeaturesSection] = React.useState<boolean>(false);
    const [openKitComponentsSection, setOpenKitComponentsSection] = React.useState<boolean>(false);
    const [openWhatsIncludedSection, setOpenWhatsIncludedSection] = React.useState<boolean>(false);

    const [keyFeaturesData, setKeyFeaturesData] = React.useState<string>();
    const [kitComponentsData, setKitComponentsData] = React.useState<SectionOptionModel[] | null>(null);
    const [whatsIncludedData, setWhatsIncludedData] = React.useState<string>();

    React.useEffect(() => {
        const keyFeaturesData = product?.properties?.featureBullets1to3
        setKeyFeaturesData(keyFeaturesData);

        let configSections;
        let kitDataList;

        if (product && product?.detail?.configuration && product.detail.configuration.configSections && product.detail.configuration.configSections[0]) {
            configSections = product.detail.configuration.configSections[0];
        }
        if (configSections) {
            kitDataList = configSections?.sectionOptions;
            setKitComponentsData(kitDataList);
        }

        const attribute = product.attributeTypes?.find(t => t.name === 'Package Contents');
        const whatsIncluded = attribute && attribute!.attributeValues!.length > 0 ? attribute!.attributeValues![0].value : '';
        setWhatsIncludedData(whatsIncluded);
    }, [product?.properties?.featureBullets1to3]);

    React.useEffect(() => {
        setOpenKeyFeaturesSection(!!keyFeaturesData);
        (openKeyFeaturesSection == false && openWhatsIncludedSection == false) ? setOpenKitComponentsSection(true) : setOpenKitComponentsSection(!!kitComponentsData && !keyFeaturesData && !whatsIncludedData);
        (openKeyFeaturesSection == false && openKitComponentsSection == false) ? setOpenWhatsIncludedSection(true) : setOpenWhatsIncludedSection(!!whatsIncludedData && !keyFeaturesData && !kitComponentsData);

    }, [keyFeaturesData, kitComponentsData, whatsIncludedData]);

    const productDetailsShippingCountdownStyles: ProductDetailsShippingCountdownStyles = {
        containerStyles: {
            css: css`
                font-size: 14px;
                position: relative;
                padding: 8px 0 10px 0;
                .top-main-features-heading {
                    display: flex;
                    gap: 30px;
                    color: ${ADIColors.blue5};
                    border-bottom: 1.8px solid ${ADIColors.gray2};
                    font-weight: 600;
                    min-height: 30px;
                    margin-bottom: 7px;
                    margin-top: 0px;
                    .top-main-features-heading-title {
                        &:hover {
                            cursor: pointer;
                        }
                        padding-bottom: 9px;
                        line-height: normal;
                    }
                }
                .keyFeaturesTitle {
                    ${openKeyFeaturesSection && `border-bottom: 1.8px solid ${ADIColors.blue5};`}
                }
                .kitComponentsTitle {
                    ${openKitComponentsSection && `border-bottom: 1.8px solid ${ADIColors.blue5};`}
                }
                .whatsIncludedTitle {
                    ${openWhatsIncludedSection && `border-bottom: 1.8px solid ${ADIColors.blue5};`}
                }
            `
        },
        dataContainerStyles: {
            css: css`
                min-height: initial;
                overflow-y: auto;
                max-height: 190px;
                scrollbar-width: thin;
                scrollbar-color: ${ADIColors.lightblue2} ${ADIColors.gray7};
                @-moz-document url-prefix() {
                    scrollbar-width: 8px;
                    scrollbar-color: ${ADIColors.lightblue2} ${ADIColors.gray7};
                }
                &::-webkit-scrollbar {
                    width: 8px;
                }

                &::-webkit-scrollbar-track {
                    background: ${ADIColors.gray7};
                }

                &::-webkit-scrollbar-thumb {
                    background-color: ${ADIColors.lightblue2};
                    border-radius: 0px;
                }
                ul {
                    padding: 0 0 0 22px;
                    margin: 0;
                    margin-left: -6px;
                    li {
                        padding-bottom: 8px;
                    }
                }
                ul {
                    @supports (-webkit-overflow-scrolling: touch) {
                        padding: 0 0 0 22px;
                        margin-left: -6px;
                    }
                    @media only screen and (min-device-width: 1024px) and (min-device-height: 768px) {
                        padding: 0 0 0 22px;
                        margin-left: -6px;
                    }
                }
                .keyFeaturesData {
                    display: ${openKeyFeaturesSection ? "block" : "hidden"};
                }
                .whatsIncludedData {
                    display: ${openWhatsIncludedSection ? "block" : "hidden"};
                }
                .kitComponentsData {
                    display: ${openWhatsIncludedSection ? "block" : "hidden"};
                    min-height: initial;
                    max-height: 190px;
                    overflow-y: auto;
                    scrollbar-color: ${ADIColors.lightblue2} ${ADIColors.gray7};
                    scrollbar-width: thin;
                    padding-right: 10px;

                    &::-webkit-scrollbar {
                        width: 4px;
                    }
                    &::-webkit-scrollbar-track {
                        background: ${ADIColors.gray6};
                    }
                    &::-webkit-scrollbar-thumb {
                        background-color: ${ADIColors.lightblue2};
                        border-radius: 7px;
                    }

                    ${({ theme }) => { return breakpointMediaQueries(
                        theme, [css` max-height: 252px; `,],"max",); 
                    }}
                    
                    >ul {
                        margin: 0;
                        > li {
                            margin-bottom: 8px;
                            >a {
                                text-decoration: none;
                                >span {
                                    color: ${ADIColors.darkBlack3};
                                }
                                &:visited, &:hover {
                                    color: ${ADIColors.blue5};
                                    text-decoration: underline;
                                }
                            }
                        }
                    }
                }
            `
        },
        productCompareCheckbox: {
            css: css`
                width: 100%;
                position: absolute;
                >[data-test-selector="ProductComapreCheckbox"] {
                    padding-top: 0px !important;
                    > div > [data-id="checkbox"] {
                        cursor: pointer;
                        > label {
                            margin-right: 0px;
                        }
                    }                    
                }
            `
        },
        spanHeader: {
            css: css`
                font-weight: bold;
                color: ${ADIColors.darkBlack3};
                line-height: 1.71;
            `
        }
    }

    const styles = productDetailsShippingCountdownStyles;

    const handleActiveTab = (selectedTab: string, selectedDataTab?: string) => {
        setOpenKeyFeaturesSection(selectedTab === 'keyFeaturesTitle');
        setOpenKitComponentsSection(selectedTab === 'kitComponentsTitle');
        setOpenWhatsIncludedSection(selectedTab === 'whatsIncludedTitle');
    }

    const displayWhatsIncludedTitleConditional = (): boolean => {
        if (whatsIncludedData) {
            if (isAuthenticated && kitComponentsData) {
                return false;
            }
            return true
        }
        return false;
    }
    return (
        <>
            <StyledWrapper {...styles.containerStyles}>
                <StyledWrapper {...styles.productCompareCheckbox}>
                    <ProductComapreCheckbox></ProductComapreCheckbox>
                </StyledWrapper>
                <StyledWrapper className="top-main-features-heading">
                    {
                        keyFeaturesData &&
                        <StyledWrapper className="top-main-features-heading-title keyFeaturesTitle" onClick={() => { handleActiveTab("keyFeaturesTitle", "keyFeaturesData") }}>{translate("Key Features")}</StyledWrapper>
                    }
                    {
                        kitComponentsData && isAuthenticated &&
                        <StyledWrapper className="top-main-features-heading-title kitComponentsTitle" onClick={() => { handleActiveTab("kitComponentsTitle", "kitComponentsData") }}>{translate("Kit Components")}</StyledWrapper>
                    }
                    {
                        displayWhatsIncludedTitleConditional() &&
                        <StyledWrapper className="top-main-features-heading-title whatsIncludedTitle" onClick={() => { handleActiveTab("whatsIncludedTitle", "whatsIncludedData") }}>{translate("What's Included")}</StyledWrapper>
                    }
                </StyledWrapper>
                <StyledWrapper className="top-main-features-data-container" {...styles.dataContainerStyles}>
                    {
                        keyFeaturesData && openKeyFeaturesSection &&
                        <StyledWrapper className="top-main-features-data-tab keyFeaturesData">
                            {parse(keyFeaturesData, parserOptions)}
                        </StyledWrapper>
                    }
                    {
                        kitComponentsData && openKitComponentsSection &&
                        <StyledWrapper className="top-main-features-data-tab kitComponentsData">
                            <Typography as="span" {...styles.spanHeader}>
                                {translate("Kit Includes:")}
                            </Typography>
                            <UnorderedList>
                                {kitComponentsData?.map((kitData: SectionOptionModel) => (
                                    <ListItem>
                                        <Link href={`/Product/${kitData?.name}`} target="_blank">
                                            {kitData.description} {translate(" Qty: ")} {kitData.quantity}
                                        </Link>
                                    </ListItem>
                                ))}
                            </UnorderedList>
                        </StyledWrapper>
                    }
                    {
                        whatsIncludedData && openWhatsIncludedSection &&
                        <StyledWrapper className="top-main-features-data-tab whatsIncludedData">
                            {whatsIncludedData?.length > 0 && parse(whatsIncludedData, parserOptions)}
                        </StyledWrapper>
                    }
                </StyledWrapper>
            </StyledWrapper>
        </>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(withProduct(ProductDetailsShippingCountdown)),
    definition: {
        group: "Product Details",
        allowedContexts: [ProductDetailsPageContext, CartPageContext],
        displayName: "Product Details Top Main Features"
    },
};

export default widgetModule;
